import React from 'react';

interface GameControlsProps {
  hasGuessed: boolean;
  hintRequested: boolean;
  skipsLeft: number;
  onGuess: () => void;
  onHint: () => void;
  onSkip: () => void;
  onNext: () => void;
  showSkipButton?: boolean;
  allDigitsRevealed?: boolean;
  isLastRound?: boolean; // New prop to indicate last round
  selectingDigit?: boolean; // New prop to indicate if in digit selection mode
}

const GameControls: React.FC<GameControlsProps> = ({
  hasGuessed,
  hintRequested,
  skipsLeft,
  onGuess,
  onHint,
  onSkip,
  onNext,
  showSkipButton = true,
  allDigitsRevealed = false,
  isLastRound = false, // Default to false
  selectingDigit = false, // Default to false
}) => {
  if (hasGuessed) {
    return (
      <button
        onClick={onNext}
        className="w-full h-12 bg-gradient-to-b from-[#7236DC] to-[#602CBC] rounded text-white uppercase font-bold text-base mb-3 next-btn"
      >
        {isLastRound ? 'View Results' : 'Next'}
      </button>
    );
  }

  return (
    <div>
      <button
        onClick={onGuess}
        disabled={selectingDigit} // Disable when in digit selection mode
        className={`w-full h-12 rounded text-white uppercase font-bold text-base mb-3 guess-btn
          ${
            selectingDigit
              ? 'bg-[#222222]/30 text-white/30 cursor-not-allowed'
              : 'bg-gradient-to-b from-[#7236DC] to-[#602CBC] hover:from-[#8347ED] hover:to-[#7236DC]'
          }`}
      >
        Guess
      </button>
      <div className="flex justify-between">
        <button
          onClick={onHint}
          disabled={allDigitsRevealed}
          className={`w-full h-10 flex items-center justify-center gap-1 rounded border uppercase font-bold text-[13px]
            ${
              allDigitsRevealed
                ? 'bg-[#222222]/30 border-[#222222] text-white/30 cursor-not-allowed'
                : selectingDigit
                  ? 'bg-[#333333]/30 border-[#333333] text-white hover:bg-[#333333]/50' // Keep same styling for Go Back
                  : 'bg-[#333333]/30 border-[#333333] text-white hover:bg-[#333333]/50'
            }
          `}
        >
          <span>{selectingDigit ? 'Go Back' : 'Reveal Digit'}</span>
        </button>

        {showSkipButton && (
          <button
            onClick={onSkip}
            disabled={skipsLeft <= 0}
            className={`w-[140px] h-10 flex ml-3 items-center justify-center gap-1 rounded border uppercase font-bold text-[13px]
              ${
                skipsLeft <= 0
                  ? 'bg-[#222222]/30 border-[#222222] text-white/30 cursor-not-allowed'
                  : 'bg-[#333333]/30 border-[#333333] text-white hover:bg-[#333333]/50'
              }
            `}
          >
            <span>Skip {skipsLeft > 0 ? `(${skipsLeft})` : ''}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default GameControls;
